// CONSTANTS
export const MAX_FILE_SIZE__DEPRECATED = 4 * 1024 * 1024
export const MAX_FILE_SIZE = 4 * 1000 * 1000
export const SUPPORTED_FORMATS = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "image/x-png",
]
